import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { setRadiusValue } from 'src/redux/actions/searchParams';
import { setRadiusOpen } from 'src/redux/actions/view';
import LocationRadius from 'src/components/LocationRadius';


const LocationRadiusContainer = ({
  radiusOpen, radiusDisabled, value, actions
}) => (
  <LocationRadius
    actions={ actions }
    radiusDisabled={ radiusDisabled }
    radiusOpen={ radiusOpen }
    value={ value }
  />
);

LocationRadiusContainer.propTypes = {
  actions: PropTypes.shape({
    setRadiusOpen: PropTypes.func,
    setRadiusValue: PropTypes.func
  }),
  radiusDisabled: PropTypes.bool,
  radiusOpen: PropTypes.bool,
  value: PropTypes.number
};

LocationRadiusContainer.defaultProps = {
  actions: {
    setRadiusValue: () => {},
    setRadiusOpen: () => {}
  },
  radiusDisabled: false,
  radiusOpen: false,
  value: 0
};

const mapStateToProperties = state => (
  {
    value: state.searchParamsReducer.current.radius,
    radiusOpen: state.viewReducer.radiusOpen,
    radiusDisabled: state.searchParamsReducer.current.radiusDisabled
  }
);

const mapDispatchToProperties = dispatch => (
  {
    actions: bindActionCreators({ setRadiusValue, setRadiusOpen }, dispatch)
  }
);

export default connect(mapStateToProperties, mapDispatchToProperties)(LocationRadiusContainer);
